<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-multi-select-edit-control [(ngModel)]="model.data.actionType"
                                                               [formControlName]="'actionType'">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="802"
                                                           label="wbo.order-history-audit-report.option.actionType.addToOrder"></wbo-select-option>
                                        <wbo-select-option [value]="800"
                                                           label="wbo.order-history-audit-report.option.actionType.void"></wbo-select-option>
                                        <wbo-select-option [value]="801"
                                                           label="wbo.order-history-audit-report.option.actionType.transfer"></wbo-select-option>
                                        <wbo-select-option [value]="804"
                                                           label="wbo.order-history-audit-report.option.actionType.courseAway"></wbo-select-option>
                                    </wbo-select-options>
                                </wbo-multi-select-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-entity-group-by-report-criteria [showActionOption]="true"
                                                                     [showEmployeeOption]="true"
                                                                     [showProductOption]="true">
                                </wbo-entity-group-by-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-entity-sub-group-by-report-criteria [showOutletOption]="showOutletOption"></wbo-entity-sub-group-by-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-sellable-report-selection></wbo-sellable-report-selection>
            </fui-row>
            <fui-row>
                <wbo-employee-report-selection></wbo-employee-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
